export default __webpack_public_path__ + "static/media/speaker.93f31529.png";